<div class="m3-payor-allocate-container">

  <!-- Header -->
  <div class="modal-header">
    <h3 class="modal-title">
      {{ title }}
      <i class="fa fa-times pull-right close-icon" (click)="cancel()"></i>
      <i class="fa pull-right toggle-icon"
        [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
        (click)="minimise = !minimise"></i>
    </h3>
  </div>

  <!-- Body -->
  @if (!minimise) {
<div class="modal-body">

    <!-- Loader -->
    @if (showFormLoader) {
<div class="formLoader">
      <i class="fa fa-spinner fa-pulse fa-2x"></i>
    </div>
}

    <!-- Tabs -->
    @if (!showFormLoader) {
<div>
      <ul class="nav nav-pills">
        <li [class.active]="activeTab === 'payorAllocation'">
          <a (click)="activeTab = 'payorAllocation'" class="nav-link-pill">Payor Allocation</a>
        </li>
        <li [class.active]="activeTab === 'setupPayor'">
          <a (click)="activeTab = 'setupPayor'" class="nav-link-pill">Setup New Third Party Payor</a>
        </li>
      </ul>

      <!-- Tab: Payor Allocation -->
      @if (activeTab === 'payorAllocation') {
<div>
        @if (loadingAccounts) {
<div class="loading-indicator">
          <i class="fa fa-spinner fa-pulse"></i>
        </div>
}

        <form name="batchPayorForm" novalidate autocomplete="off">
          @for (entity of entityData; track $index; let mainIndex = $index) {
<div class="entity-block">

            <!-- Entity Header Row -->
            <div class="row">
              <div class="col-md-1 LayerData1"></div>
              <div class="col-md-2 LayerData1 centerText">
                <label>Entity Tax:</label><br>
                <label>{{ entity.LEID }}</label>
              </div>
              <div class="col-md-2 LayerData1 centerText">
                <label>Tax Code:</label><br>
                <label>{{ entity.CDR_NO }}</label>
              </div>
              <div class="col-md-2 LayerData1 centerText">
                <label>ME Code:</label><br>
                <label>{{ entity.ME_CODE }}</label>
              </div>
              <div class="col-md-2 LayerData1 centerText">
                <label>Reporting Period:</label><br>
                <label>{{ entity.REP_PD }}</label>
              </div>
              <div class="col-md-2 LayerData1 centerText">
                <label>Ledger:</label><br>
                <label>{{ entity.LEDGER }}</label>
              </div>
              <div class="col-md-1 LayerData1"></div>
            </div>

            <hr>

            <!-- System Account Rows (M3PAYOR) -->
            @if (paymentType === 'M3PAYOR') {
<div>
              @for (sys_acct of entity.Sys_Account_data; track $index; let sysacctIndex = $index) {
<div class="sys-acct-block">

                <!-- System Account Header Row -->
                <div class="row">
                  <div class="col-md-1"></div>
                  <div class="col-md-1 gt-edit-col centerText">
                    @if (!sys_acct.IS_OPEN) {
<i
                      class="fa fa-plus-circle color-green pointer"
                      title="Open Details"
                      (click)="openSubDetails(mainIndex, sysacctIndex, 'O')"></i>
}
                    @if (sys_acct.IS_OPEN) {
<i
                      class="fa fa-minus-circle color-red pointer"
                      title="Close Details"
                      (click)="openSubDetails(mainIndex, sysacctIndex, 'C')"></i>
}
                  </div>
                  <div class="col-md-1 centerText">
                    <label>Line No:</label>
                    <span>{{ sys_acct.LINE }}</span>
                  </div>
                  <div class="col-md-2 centerText">
                    <label>System Account: </label>
                    <label><b>{{ sys_acct.TO_ACCT }} - {{ sys_acct.TO_ACCT_DESC }}</b></label>
                  </div>
                  <div class="col-md-2 centerText">
                    <label>Book Amount: </label>
                    <span>{{ sys_acct.SYS_BOOK_AMT | number:'1.0-0' }}</span>
                  </div>
                  <div class="col-md-2 centerText">
                    <label>Tax Adjustment: </label>
                    <span>{{ sys_acct.SYS_TAX_ADJ | number:'1.0-0' }}</span>
                  </div>

                  <!-- Validation / Total col -->
                  @if (sys_acct.IS_VALIDATE == 1 && sys_acct.LINE === '1' && sys_acct.SYS_TOTAL_AMT === 0) {
<div class="col-md-2 centerText"
                   
                    style="color:green;">
                    <label>Total Net to Zero</label>
                  </div>
}
                  @if (sys_acct.IS_VALIDATE == 1 && sys_acct.LINE === '1' && sys_acct.SYS_TOTAL_AMT !== 0) {
<div class="col-md-2 centerText"
                   
                    style="color:red;">
                    <label>Total not Net to Zero</label>
                  </div>
}
                  @if (sys_acct.LINE !== '1') {
<div class="col-md-2 centerText">
                    <label>Total Amount: </label>
                    <span>{{ sys_acct.SYS_TOTAL_AMT | number:'1.0-0' }}</span>
                  </div>
}

                  <!-- Allocation status col -->
                  @if (sys_acct.IS_SYS_TOTAL_ALLOCATED == 1) {
<div class="col-md-1 centerText" style="color:green;">
                    <label>Allocation Completed</label>
                  </div>
}
                  @if (sys_acct.IS_SYS_TOTAL_ALLOCATED != 1) {
<div class="col-md-1 centerText" style="color:red;">
                    <label>Allocation Incomplete</label>
                  </div>
}
                </div>

                <!-- Expanded Details -->
                @if (sys_acct.IS_OPEN) {
<div class="sub-details">
                  <hr>
                  <!-- Column Headers -->
                  <div class="row">
                    <div class="col-md-2 centerText"><label>Transaction Type</label></div>
                    <div class="col-md-1 gt-edit-col"></div>
                    <div class="col-md-2 centerText"><label>Account</label></div>
                    <div class="col-md-2 centerText"><label>Trading Partner</label></div>
                    <div class="col-md-2 centerText"><label>Amount</label></div>
                    <div class="col-md-2 centerText"><label>Payor Type</label></div>
                    <div class="col-md-1 centerText"><label>Payor Name</label></div>
                  </div>

                  <!-- Account data rows -->
                  @for (account of sys_acct.Account_data; track $index; let acctIndex = $index) {
<div>
                    <hr>
                    @for (sub_acct of account.sub_acct_data; track $index; let subIndex = $index) {
<div class="row sub-acct-row">

                      <!-- Transaction Type -->
                      <div class="col-md-2 centerText">
                        <label>{{ sub_acct.TRANS_TYPE }}</label>
                      </div>

                      <!-- Action buttons -->
                      <div class="col-md-1 gt-edit-col">
                        @if (sub_acct.AMT_TYPE === 'M_ADJUSTMENT') {
<span></span>
}
                        @if (sub_acct.AMT_TYPE === 'BOOK_AMT' && sub_acct.ROW_TYPE === 'TB') {
<span></span>
}
                        @if (sub_acct.AMT_TYPE === 'BOOK_AMT' && sub_acct.ROW_TYPE === 'HEADER_ROW') {
<i
                          class="fa fa-plus-circle color-green pointer"
                          title="Add New Payor"
                          (click)="addNewPayor(mainIndex, sysacctIndex, acctIndex, subIndex)"></i>
}
                        @if (sub_acct.AMT_TYPE === 'BOOK_AMT' && (sub_acct.ROW_TYPE === 'NEW' || sub_acct.ROW_TYPE === 'EX')) {
<i
                          class="fa fa-minus-circle color-red pointer"
                          title="Remove This Payor"
                          (click)="removePayor(mainIndex, sysacctIndex, acctIndex, subIndex)"></i>
}
                      </div>

                      <!-- Account -->
                      <div class="col-md-2 centerText">
                        @if (sub_acct.AMT_TYPE === 'BOOK_AMT' && sub_acct.ROW_TYPE === 'HEADER_ROW') {
<label>
                          {{ sub_acct.FROM_ACCT }} - {{ sub_acct.FROM_ACCT_DESC }}
                        </label>
}
                        @if (sub_acct.AMT_TYPE === 'BOOK_AMT' && sub_acct.ROW_TYPE !== 'HEADER_ROW') {
<input
                          type="text" readonly class="form-control input-sm"
                          [value]="sub_acct.FROM_ACCT + ' - ' + sub_acct.FROM_ACCT_DESC">
}
                        @if (sub_acct.AMT_TYPE === 'M_ADJUSTMENT') {
<input
                          type="text" readonly class="form-control input-sm"
                          [value]="sub_acct.FROM_ACCT + ' - ' + sub_acct.FROM_ACCT_DESC
                                   + (sub_acct.SCHDM_TEMPLATE_KEY != null ? ' - ' + sub_acct.SCHDM_TEMPLATE_KEY : '')
                                   + (sub_acct.ADJ_ORIGIN_SOURCE != null ? ' - ' + sub_acct.ADJ_ORIGIN_SOURCE : '')">
}
                      </div>

                      <!-- Trading Partner / Book Amt -->
                      <div class="col-md-2 centerText">
                        @if (sub_acct.AMT_TYPE === 'BOOK_AMT' && sub_acct.ROW_TYPE === 'HEADER_ROW') {

                          <label>Book Amt: </label>
                          <span>{{ sub_acct.BOOK_AMT | number:'1.0-0' }}</span>
                        
}

                        @if ((sub_acct.AMT_TYPE === 'BOOK_AMT' || sub_acct.AMT_TYPE === 'M_ADJUSTMENT') && (sub_acct.ROW_TYPE === 'TB' || sub_acct.ROW_TYPE === 'EX')) {

                          @if (sub_acct.AMT_TYPE !== 'M_ADJUSTMENT' || sub_acct.ROW_TYPE !== 'EX') {
<input
                            type="text" disabled class="form-control input-sm"
                            [value]="sub_acct.TP_DETAILS?.TP_ENTITY || sub_acct.TP_ENTITY || ''">
}
                          @if (sub_acct.AMT_TYPE === 'M_ADJUSTMENT' && sub_acct.ROW_TYPE === 'EX') {
<div class="tp-search-container">
                            <div class="input-group">
                              <input type="text"
                                class="form-control input-sm"
                                placeholder="begin typing to select trading partner"
                                [(ngModel)]="sub_acct.TP_SEARCH"
                                [ngModelOptions]="{standalone: true}"
                                (focus)="activeTpField = sub_acct"
                                (ngModelChange)="searchTradingPartners(sub_acct.LINE, $event, sub_acct)"
                                (blur)="delayedClearResults()">
                              <span class="input-group-addon">
                                @if (tpSearchLoading) {
<i class="fa fa-spinner fa-pulse"></i>
}
                                @if (!tpSearchLoading) {
<i class="fa fa-search"></i>
}
                              </span>
                            </div>
                            @if (tpSearchResults.length > 0 && activeTpField === sub_acct) {
<div class="tp-dropdown">
                              @for (tp of tpSearchResults; track $index) {
<div class="tp-option"
                                (mousedown)="setTradingPartner(tp, mainIndex, sysacctIndex, acctIndex, subIndex)">
                                {{ tp.TP_ENTITY }}
                              </div>
}
                            </div>
}
                          </div>
}
                        
}

                        @if (sub_acct.AMT_TYPE === 'BOOK_AMT' && sub_acct.ROW_TYPE === 'NEW') {

                          <div class="tp-search-container">
                            <div class="input-group">
                              <input type="text"
                                class="form-control input-sm"
                                placeholder="begin typing to select trading partner"
                                [(ngModel)]="sub_acct.TP_LOAD"
                                [ngModelOptions]="{standalone: true}"
                                (focus)="activeTpField = sub_acct"
                                (ngModelChange)="searchTradingPartners(sub_acct.LINE, $event, sub_acct)"
                                (blur)="delayedClearResults()">
                              <span class="input-group-addon">
                                @if (tpSearchLoading) {
<i class="fa fa-spinner fa-pulse"></i>
}
                                @if (!tpSearchLoading) {
<i class="fa fa-search"></i>
}
                              </span>
                            </div>
                            @if (tpSearchResults.length > 0 && activeTpField === sub_acct) {
<div class="tp-dropdown">
                              @for (tp of tpSearchResults; track $index) {
<div class="tp-option"
                                (mousedown)="setTradingPartner(tp, mainIndex, sysacctIndex, acctIndex, subIndex)">
                                {{ tp.TP_ENTITY }}
                              </div>
}
                            </div>
}
                          </div>
                          @if (sub_acct.HAS_ERROR === 'Y') {
<span class="form-error-container">
                            {{ sub_acct.TP_ERROR }}
                          </span>
}
                        
}
                      </div>

                      <!-- Amount -->
                      <div class="col-md-2 centerText">
                        @if (sub_acct.AMT_TYPE === 'BOOK_AMT' && sub_acct.ROW_TYPE === 'HEADER_ROW') {

                          <label>Allocated Amt: </label>
                          <span>{{ sub_acct.TOTAL_ALLOCATED_AMT | number:'1.0-0' }}</span>
                        
}

                        @if (sub_acct.AMT_TYPE === 'BOOK_AMT' && (sub_acct.ROW_TYPE === 'TB' || sub_acct.ROW_TYPE === 'EX')) {
<div>
                          <input type="text" readonly class="form-control input-sm numText"
                            [ngModel]="sub_acct.ALLOCATED_AMT" [ngModelOptions]="{standalone: true}">
                        </div>
}

                        @if (sub_acct.AMT_TYPE === 'BOOK_AMT' && sub_acct.ROW_TYPE === 'NEW') {
<div>
                          <input type="number" class="form-control input-sm numText"
                            [(ngModel)]="sub_acct.ALLOCATED_AMT" [ngModelOptions]="{standalone: true}"
                            (blur)="updateAmount(mainIndex, sysacctIndex, acctIndex, subIndex, 'I')">
                        </div>
}

                        @if (sub_acct.AMT_TYPE === 'M_ADJUSTMENT') {
<div class="noWrap numText">
                          <input type="text" readonly class="form-control input-sm numText"
                            [ngModel]="sub_acct.ALLOCATED_AMT" [ngModelOptions]="{standalone: true}">
                        </div>
}
                      </div>

                      <!-- Payor Type -->
                      <div class="col-md-2 centerText">
                        @if (sub_acct.AMT_TYPE === 'BOOK_AMT' && sub_acct.ROW_TYPE === 'HEADER_ROW') {

                          <label>Unallocated Amt: </label>
                          <span>{{ sub_acct.UNALLOCATED_AMT | number:'1.0-0' }}</span>
                        
}

                        @if (sub_acct.AMT_TYPE === 'M_ADJUSTMENT' && sub_acct.ROW_TYPE === 'EX' && sub_acct.LINE === '1' && sub_acct.IS_OTHER_PAYOR === 'Y') {

                          <select class="form-control input-sm"
                            [(ngModel)]="sub_acct.PAYOR_TYPE" [ngModelOptions]="{standalone: true}"
                            (change)="setPayorType(sub_acct.PAYOR_TYPE, mainIndex, sysacctIndex, acctIndex, subIndex)">
                            <option [ngValue]="null">-- Select --</option>
                            @for (type of M3PayorTypes; track $index) {
<option [ngValue]="type.PAYOR_TYPE">{{ type.PAYOR_TYPE }}</option>
}
                          </select>
                          @if (sub_acct.HAS_TYPE_ERROR === 'Y') {
<span class="form-error-container">
                            {{ sub_acct.PAYOR_TYPE_ERROR }}
                          </span>
}
                        
}

                        @if (sub_acct.AMT_TYPE === 'BOOK_AMT' && sub_acct.ROW_TYPE === 'EX' && sub_acct.LINE === '1' && sub_acct.IS_OTHER_PAYOR === 'Y') {

                          <select class="form-control input-sm" disabled
                            [(ngModel)]="sub_acct.PAYOR_TYPE" [ngModelOptions]="{standalone: true}">
                            <option [ngValue]="null">-- Select --</option>
                            @for (type of M3PayorTypes; track $index) {
<option [ngValue]="type.PAYOR_TYPE">{{ type.PAYOR_TYPE }}</option>
}
                          </select>
                        
}

                        @if (sub_acct.AMT_TYPE === 'BOOK_AMT' && sub_acct.ROW_TYPE === 'NEW' && sub_acct.LINE === '1' && sub_acct.IS_OTHER_PAYOR === 'Y') {

                          <select class="form-control input-sm"
                            [(ngModel)]="sub_acct.PAYOR_TYPE" [ngModelOptions]="{standalone: true}"
                            (change)="setPayorType(sub_acct.PAYOR_TYPE, mainIndex, sysacctIndex, acctIndex, subIndex)">
                            <option [ngValue]="null">-- Select --</option>
                            @for (type of M3PayorTypes; track $index) {
<option [ngValue]="type.PAYOR_TYPE">{{ type.PAYOR_TYPE }}</option>
}
                          </select>
                          @if (sub_acct.HAS_TYPE_ERROR === 'Y') {
<span class="form-error-container">
                            {{ sub_acct.PAYOR_TYPE_ERROR }}
                          </span>
}
                        
}
                      </div>

                      <!-- Payor Name -->
                      <div class="col-md-1 centerText">
                        @if (sub_acct.AMT_TYPE === 'M_ADJUSTMENT' && sub_acct.ROW_TYPE === 'EX' && sub_acct.IS_OTHER_PAYOR === 'Y') {

                          @if (isThirdPartyEnabled === 'Y') {
<select class="form-control input-sm"
                            [(ngModel)]="sub_acct.PAYOR_NAME" [ngModelOptions]="{standalone: true}"
                            (change)="updatedDetails(mainIndex, sysacctIndex, acctIndex, subIndex)">
                            <option [ngValue]="null">-- Select --</option>
                            @for (tp of thirdPartyData; track $index) {
<option [ngValue]="tp.PAYOR_NAME">{{ tp.PAYOR_NAME }}</option>
}
                          </select>
}
                          @if (isThirdPartyEnabled === 'N') {
<input type="text" maxlength="30" class="form-control input-sm"
                            [(ngModel)]="sub_acct.PAYOR_NAME" [ngModelOptions]="{standalone: true}"
                            (change)="updatedDetails(mainIndex, sysacctIndex, acctIndex, subIndex)">
}
                          @if (sub_acct.HAS_NAME_ERROR === 'Y') {
<span class="form-error-container">
                            {{ sub_acct.PAYOR_NAME_ERROR }}
                          </span>
}
                        
}

                        @if (sub_acct.AMT_TYPE === 'BOOK_AMT' && sub_acct.ROW_TYPE === 'EX' && sub_acct.IS_OTHER_PAYOR === 'Y') {

                          <input type="text" readonly maxlength="30" class="form-control input-sm"
                            [ngModel]="sub_acct.PAYOR_NAME" [ngModelOptions]="{standalone: true}">
                        
}

                        @if (sub_acct.AMT_TYPE === 'BOOK_AMT' && sub_acct.ROW_TYPE === 'NEW' && sub_acct.IS_OTHER_PAYOR === 'Y') {

                          @if (isThirdPartyEnabled === 'Y') {
<select class="form-control input-sm"
                            [(ngModel)]="sub_acct.PAYOR_NAME" [ngModelOptions]="{standalone: true}"
                            (change)="updatedDetails(mainIndex, sysacctIndex, acctIndex, subIndex)">
                            <option [ngValue]="null">-- Select --</option>
                            @for (tp of thirdPartyData; track $index) {
<option [ngValue]="tp.PAYOR_NAME">{{ tp.PAYOR_NAME }}</option>
}
                          </select>
}
                          @if (isThirdPartyEnabled === 'N') {
<input type="text" maxlength="30" class="form-control input-sm"
                            [(ngModel)]="sub_acct.PAYOR_NAME" [ngModelOptions]="{standalone: true}"
                            (change)="updatedDetails(mainIndex, sysacctIndex, acctIndex, subIndex)">
}
                          @if (sub_acct.HAS_NAME_ERROR === 'Y') {
<span class="form-error-container">
                            {{ sub_acct.PAYOR_NAME_ERROR }}
                          </span>
}
                        
}
                      </div>

                    </div>
}
                  </div>
}
                  <hr>
                </div>
}

              </div>
}
            </div>
}
          </div>
}
        </form>
      </div>
}

      <!-- Tab: Setup New Third Party Payor -->
      @if (activeTab === 'setupPayor') {
<div class="tab-content">
        <div class="setup-payor-form">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Payor Name: </label>
                <input type="text" [(ngModel)]="payorName" class="form-control">
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Payor EIN: </label>
                <input type="text" [(ngModel)]="payorEin" class="form-control">
              </div>
            </div>
          </div>
        </div>
      </div>
}
    </div>
}
  </div>
}

  <!-- Footer -->
  @if (!minimise) {
<div class="modal-footer">
    @if (isAllocateAccess) {
<button class="btn btn-info btn-sm" type="button" (click)="allocatePayor()" [disabled]="crudLoading">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
      Allocation Process
    </button>
}
    <button class="btn btn-info btn-sm" type="button" (click)="save()" [disabled]="crudLoading">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
      Save
    </button>
    <button class="btn btn-default btn-sm" type="button" (click)="reset()">Reset</button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
  </div>
}

</div>
